function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var IdentityTemplate = require('./identity.template');
var IdentityPrompt = /*#__PURE__*/function () {
  function IdentityPrompt(app, mod) {
    _classCallCheck(this, IdentityPrompt);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.overlay["class"] = 'saito-overlay saitosign-overlay';
    this.hooks = {};
  }
  return _createClass(IdentityPrompt, [{
    key: "render",
    value: function render(name) {
      var _this = this;
      var hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.hooks = hooks;
      this.overlay.show(IdentityTemplate(name), function () {
        if (_this.hooks.onClose) {
          _this.hooks.onClose();
        }
      });
      var form = document.querySelector('.saitosign-identity');
      if (!form) {
        return;
      }
      form.addEventListener('click', function (event) {
        var choice = event.target.closest('[data-identity]');
        if (!choice) {
          return;
        }
        event.preventDefault();
        var yes = choice.dataset.identity === 'yes';
        _this.overlay.close();
        if (yes && _this.hooks.onYes) {
          _this.hooks.onYes();
        }
      });
    }
  }]);
}();
module.exports = IdentityPrompt;